<template lang="pug">
.auth
  //- ============ PAINEL DE MARCA ============
  aside.auth__brand
    .auth__grid
    .auth__glow.auth__glow--blue
    .auth__glow.auth__glow--red
    .auth__brand-inner
      router-link.auth__logo(to="/Home")
        img(:src="lbrLogo" alt="LBR")
        span Liga Brasileira de Robótica
      .auth__brand-copy
        p.auth__eyebrow
          span.auth__pip
          | Área do competidor
        h2.auth__headline
          | Bem-vindo de
          |
          span.hl volta à arena
          | .
        p.auth__lead
          | Acesse para gerenciar sua equipe, inscrever robôs e acompanhar
          | chaves, lutas e resultados das competições.
      .auth__stage
        .auth__plate.auth__plate--blue
          FontAwesomeIcon.auth__plate-ic(:icon="['fas','robot']")
          span Lado Azul
        .auth__vs VS
        .auth__plate.auth__plate--red
          FontAwesomeIcon.auth__plate-ic(:icon="['fas','robot']")
          span Lado Vermelho

  //- ============ FORMULÁRIO ============
  .auth__panel
    .auth__card
      router-link.auth__card-logo(to="/Home")
        img(:src="lbrLogo" alt="LBR")
      header.auth__head
        p.auth__tag Entrar
        h1.auth__title Acesse sua conta
        p.auth__sub Use seu e-mail ou nome de usuário e a senha cadastrados na LBR.

      form.auth__form(@submit.prevent="doSignIn")
        label.field
          span.field__label E-mail ou nome de usuário
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','user']")
            input.field__input(
              id="input-login"
              type="text"
              autocomplete="username"
              placeholder="voce@email.com ou seunick"
              v-model="login"
            )

        label.field
          span.field__label Senha
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','lock']")
            input.field__input(
              id="input-password"
              :type="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              placeholder="Sua senha"
              v-model="password"
            )
            button.field__toggle(
              type="button"
              :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
              @click="showPassword = !showPassword"
            )
              FontAwesomeIcon(:icon="['fas', showPassword ? 'eye-slash' : 'eye']")

        transition(name="fade")
          p.auth__error(v-if="showError")
            FontAwesomeIcon(:icon="['fas','circle-exclamation']")
            | Não foi possível fazer login, verifique seus dados.

        button.auth__submit(type="submit")
          span Entrar
          FontAwesomeIcon.auth__submit-ic(:icon="['fas','arrow-right']")

      p.auth__switch
        | Ainda não possui conta?
        |
        a(@click="doNavigateToSignUp") Cadastre-se
</template>

<script>
import {
  mapActions
} from 'vuex'

import lbrLogo from '@/assets/lbrLogo.webp'

export default {
  name: 'SignIn',
  data: () => ({
    lbrLogo,
    login: '',
    password: '',
    showPassword: false,
    showError: false
  }),
  methods: {
    ...mapActions('users',
      [
        'setSignIn'
      ]
    ),
    doNavigateToSignUp () {
      this.$router.push('/SignUp')
    },
    doSignIn () {
      this.showError = false
      const user = { login: this.login, password: this.password }
      this.setSignIn(user).then(resp => {
        if (!resp) {
          this.showError = true
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$red-dark: #B0231F
$ink: #0B0E14
$paper: #FFFFFF
$mist: #EEF1F6
$muted: #5C6673
$line: rgba(11, 14, 20, 0.12)

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.auth
  display: grid
  grid-template-columns: 1.05fr 1fr
  min-height: 100vh
  font-family: Lato, sans-serif
  color: $ink

  .hl
    background: linear-gradient(100deg, #5AA0FF, $red)
    -webkit-background-clip: text
    background-clip: text
    color: transparent

  // ---------- PAINEL DE MARCA ----------
  &__brand
    position: relative
    overflow: hidden
    isolation: isolate
    background: radial-gradient(circle at 18% 12%, #15233b 0%, $ink 48%, #05070b 100%)
    color: #fff
    padding: 56px 56px 48px

  &__grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.045) 1px, transparent 1px)
    background-size: 46px 46px
    mask-image: radial-gradient(circle at 50% 30%, #000 0%, transparent 80%)
    -webkit-mask-image: radial-gradient(circle at 50% 30%, #000 0%, transparent 80%)
    z-index: -2

  &__glow
    position: absolute
    width: 460px
    height: 460px
    border-radius: 50%
    filter: blur(120px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -160px
      left: -120px
    &--red
      background: $red
      bottom: -180px
      right: -120px

  &__brand-inner
    position: relative
    height: 100%
    display: flex
    flex-direction: column
    gap: 40px

  &__logo
    display: inline-flex
    align-items: center
    gap: 14px
    text-decoration: none
    color: #fff
    img
      width: 46px
      height: 46px
      object-fit: contain
    span
      font-family: $display
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.02em
      font-size: 18px
      max-width: 220px
      line-height: 1.05

  &__brand-copy
    margin-top: auto

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.2em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.72)
    margin: 0 0 18px

  &__pip
    width: 9px
    height: 9px
    border-radius: 50%
    background: $blue
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.25)

  &__headline
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(34px, 3.6vw, 54px)
    line-height: 0.96
    letter-spacing: -0.015em
    margin: 0

  &__lead
    max-width: 420px
    font-size: 16px
    color: rgba(255, 255, 255, 0.72)
    margin: 20px 0 0

  &__stage
    display: flex
    align-items: center
    gap: 14px
    margin-top: 8px
    padding: 22px
    border: 1px solid rgba(255, 255, 255, 0.10)
    border-radius: 16px
    background: linear-gradient(160deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.01))
    backdrop-filter: blur(6px)

  &__plate
    flex: 1
    display: flex
    flex-direction: column
    align-items: center
    gap: 10px
    padding: 22px 10px
    border-radius: 12px
    font-family: $mono
    font-size: 11px
    letter-spacing: 0.14em
    text-transform: uppercase
    color: rgba(255, 255, 255, 0.72)
    &--blue
      background: radial-gradient(circle at 50% 0%, rgba(40, 122, 237, 0.30), transparent 70%)
      box-shadow: inset 0 0 0 1px rgba(90, 160, 255, 0.35)
      .auth__plate-ic
        color: #6FB0FF
    &--red
      background: radial-gradient(circle at 50% 0%, rgba(221, 52, 52, 0.30), transparent 70%)
      box-shadow: inset 0 0 0 1px rgba(255, 110, 110, 0.35)
      .auth__plate-ic
        color: #FF7A7A
  &__plate-ic
    font-size: 40px

  &__vs
    display: grid
    place-items: center
    width: 50px
    height: 50px
    flex-shrink: 0
    border-radius: 50%
    font-family: $display
    font-weight: 800
    font-size: 18px
    color: #fff
    background: $ink
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.18), 0 8px 24px rgba(0, 0, 0, 0.5)

  // ---------- FORMULÁRIO ----------
  &__panel
    display: flex
    align-items: center
    justify-content: center
    padding: 48px 24px
    background: $paper

  &__card
    width: 100%
    max-width: 400px
    animation: rise .6s cubic-bezier(.2,.7,.2,1) both

  &__card-logo
    display: none

  &__head
    margin-bottom: 30px

  &__tag
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: $blue
    margin: 0 0 12px

  &__title
    font-family: $display
    font-weight: 700
    text-transform: uppercase
    font-size: clamp(30px, 4vw, 40px)
    line-height: 1.02
    letter-spacing: -0.01em
    margin: 0

  &__sub
    font-size: 15px
    color: $muted
    margin: 12px 0 0

  &__form
    display: flex
    flex-direction: column
    gap: 18px

  &__error
    display: flex
    align-items: center
    gap: 9px
    margin: 0
    padding: 12px 14px
    border-radius: 10px
    font-size: 14px
    color: $red-dark
    background: rgba(221, 52, 52, 0.08)
    border: 1px solid rgba(221, 52, 52, 0.22)

  &__submit
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 10px
    margin-top: 4px
    height: 54px
    border: none
    border-radius: 10px
    cursor: pointer
    font-family: $display
    font-weight: 600
    text-transform: uppercase
    letter-spacing: 0.06em
    font-size: 17px
    color: #fff
    background: $blue
    box-shadow: 0 10px 24px rgba(40, 122, 237, 0.35)
    transition: transform .18s ease, box-shadow .18s ease, background .18s ease
    &:hover
      background: $blue-dark
      transform: translateY(-2px)
      box-shadow: 0 14px 30px rgba(40, 122, 237, 0.45)
    &-ic
      font-size: 13px
      transition: transform .2s ease
    &:hover &-ic
      transform: translateX(4px)

  &__switch
    margin: 26px 0 0
    text-align: center
    font-size: 15px
    color: $muted
    a
      color: $blue
      font-weight: 700
      cursor: pointer
      margin-left: 4px
      &:hover
        text-decoration: underline

  // ---------- CAMPO ----------
  .field
    display: flex
    flex-direction: column
    &__label
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.1em
      font-size: 11px
      font-weight: 700
      color: $muted
      margin-bottom: 8px
    &__control
      position: relative
      display: flex
      align-items: center
      border: 1px solid $line
      border-radius: 10px
      background: #fff
      transition: border-color .18s ease, box-shadow .18s ease
      &:focus-within
        border-color: $blue
        box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.12)
    &__ic
      position: absolute
      left: 16px
      font-size: 15px
      color: $muted
      pointer-events: none
    &__input
      flex: 1
      width: 100%
      box-sizing: border-box
      border: none
      background: none
      outline: none
      height: 52px
      padding: 0 16px 0 44px
      font-size: 15px
      color: $ink
      font-family: Lato, sans-serif
      &::placeholder
        color: rgba(92, 102, 115, 0.55)
    &__toggle
      display: grid
      place-items: center
      width: 44px
      height: 44px
      margin-right: 4px
      border: none
      background: none
      color: $muted
      font-size: 15px
      cursor: pointer
      border-radius: 8px
      transition: color .18s ease, background .18s ease
      &:hover
        color: $ink
        background: $mist

  // ---------- transições ----------
  .fade-enter-active, .fade-leave-active
    transition: opacity .25s ease
  .fade-enter, .fade-leave-to
    opacity: 0

  @keyframes rise
    from
      opacity: 0
      transform: translateY(18px)
    to
      opacity: 1
      transform: none

  // ---------- responsivo ----------
  @media (max-width: 880px)
    grid-template-columns: 1fr
    &__brand
      display: none
    &__panel
      min-height: 100vh
      padding: 40px 22px
    &__card-logo
      display: flex
      justify-content: center
      margin-bottom: 26px
      img
        width: 56px
        height: 56px
        object-fit: contain
    &__head
      text-align: center
</style>
